import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 7.998H8V13.998H6V7.998H0V5.998H6V-0.0019989H8V5.998H14V7.998Z", fill: "#8C52FF" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
